import React, { useState, useEffect, useRef } from 'react';

export default function GeoLocationResolver({ setUserCoords }) {
  const [error, setError] = useState('');
  const [attempted, setAttempted] = useState(false);
  const resolvedOnce = useRef(false);

  useEffect(() => {
    if (resolvedOnce.current) return;

    if (!navigator.geolocation) {
      setError('Geolocation not supported.');
      setAttempted(true);
      resolvedOnce.current = true;
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        console.log('📍 Setting userCoords ONCE:', latitude, longitude);
        setUserCoords({ lat: latitude, lon: longitude });
        setAttempted(true);
        resolvedOnce.current = true;
      },
      (err) => {
        console.warn('❌ Geolocation failed:', err);
        setError('Geolocation permission denied.');
        setAttempted(true);
        resolvedOnce.current = true;
      },
      { timeout: 5000 }
    );
  }, []);

  return (
    <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 p-4 rounded mt-4">
      {!attempted && <p>Trying to find your location to show horses nearby...</p>}
      {error && <p>{error}</p>}
    </div>
  );
}